import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
  bgClass?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Carregando...',
  bgClass = 'bg-white',
}) => (
  <div className={`min-h-screen flex items-center justify-center ${bgClass}`}>
    <div className="flex items-center gap-2 text-gray-500">
      <Loader2 className="w-6 h-6 animate-spin" />
      <span>{message}</span>
    </div>
  </div>
);
